import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetRiesgoEmbarazoLactanciaByID = {
  status: number | null;
  statusText: string | null;
};

const useGetRiesgoEmbarazoLactanciaByID = () => {
  const [loadingGetRiesgoEmbarazoLactanciaByID, setLoadingRiesgoEmbarazoLactanciaByID] = useState(false);
  const [successGetRiesgoEmbarazoLactanciaByID, setSuccessRiesgoEmbarazoLactanciaByID] = useState(false);
  const [errorGetRiesgoEmbarazoLactanciaByID, setErrorRiesgoEmbarazoLactanciaByID] = useState<any>(null);
  const [dataGetRiesgoEmbarazoLactanciaByID, setDataCertificadoEmpresa] = useState<any>(null);

  const [statusGetRiesgoEmbarazoLactanciaByID, setStatusGetRiesgoEmbarazoLactanciaByID] =
    useState<StatusGetRiesgoEmbarazoLactanciaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getRiesgoEmbarazoLactanciaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingRiesgoEmbarazoLactanciaByID(true);
    setSuccessRiesgoEmbarazoLactanciaByID(false);
    setErrorRiesgoEmbarazoLactanciaByID(null);

    try {
      const res = await apiRecord.getSolicitudReconocimientoRELByID(userId, prestacionId, id);

      setStatusGetRiesgoEmbarazoLactanciaByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessRiesgoEmbarazoLactanciaByID(true);
      setDataCertificadoEmpresa(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetRiesgoEmbarazoLactanciaByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorRiesgoEmbarazoLactanciaByID(err);
      console.error("Error en getRiesgoEmbarazoLactanciaByID:", err);

      throw err;

    } finally {
      setLoadingRiesgoEmbarazoLactanciaByID(false);
    }
  };

  return {
    getRiesgoEmbarazoLactanciaByID,
    loadingGetRiesgoEmbarazoLactanciaByID,
    successGetRiesgoEmbarazoLactanciaByID,
    errorGetRiesgoEmbarazoLactanciaByID,
    dataGetRiesgoEmbarazoLactanciaByID,
    statusGetRiesgoEmbarazoLactanciaByID
  };
};

export default useGetRiesgoEmbarazoLactanciaByID;
